import React from 'react'
import { Icon } from '@chakra-ui/react'

export function IconManager(rest) {
  return (
    <Icon viewBox="0 0 32 32" {...rest}>
      <g
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        transform="matrix(1.375,0,0,1.375,5,4.3372)"
      >
        <path d="M8,10C5.33,10 0,11.34 0,14L0,16L16,16L16,14C16,11.34 10.67,10 8,10ZM8,10.727C9.509,10.727 11.922,11.179 13.609,12.084C14.534,12.58 15.273,13.176 15.273,14C15.273,14 15.273,15.273 15.273,15.273C15.273,15.273 0.727,15.273 0.727,15.273C0.727,15.273 0.727,14 0.727,14C0.727,13.176 1.466,12.58 2.391,12.084C4.078,11.179 6.491,10.727 8,10.727ZM8,8C10.21,8 12,6.21 12,4C12,1.79 10.21,0 8,0C5.79,0 4,1.79 4,4C4,6.21 5.79,8 8,8ZM8,7.273C6.192,7.273 4.727,5.808 4.727,4C4.727,2.192 6.192,0.727 8,0.727C9.808,0.727 11.273,2.192 11.273,4C11.273,5.808 9.808,7.273 8,7.273Z" />
      </g>
    </Icon>
  )
}
